import styled from 'styled-components';

export const Wrapper = styled.div`
	gap: 12px;
	display: flex;
	height: 180px;
	max-width: 100%;
	overflow-x: scroll;
	overflow-y: hidden;
	align-items: center;

	::-webkit-scrollbar {
		display: none;
	}
`;
